













/* eslint-disable class-methods-use-this */
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PageLoading from '@/components/PageLoading.vue';

@Component({
  components: {
    PageLoading,
  },
})
export default class LayoutUser extends Vue {
  @Getter('loading/isLoading') isLoading!: boolean;

  mounted() {
    document.body.classList.add('page-login', 'background', 'show-spinner', 'no-footer', 'rounded');
  }

  beforeDestroy() {
    document.body.classList.remove('page-login', 'background', 'show-spinner', 'no-footer', 'rounded');
  }
}
